import { config } from "../../Config";

async function getPublicExtensions(userId = "", userEmail = "") {
    let url = config.getPublicExtensions;

    // Append userId/userEmail as query params for access control filtering
    const params = [];
    if (userId) params.push(`userId=${encodeURIComponent(userId)}`);
    if (userEmail) params.push(`userEmail=${encodeURIComponent(userEmail)}`);
    if (params.length > 0) {
        url += (url.includes("?") ? "&" : "?") + params.join("&");
    }

    try {
        const response = await fetch(url, {
            method: "GET",
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
                `Failed to fetch public extensions: ${response.status} ${response.statusText} - ${errorText}`
            );
        }

        const extensions = await response.json();
        return extensions;
    } catch (error) {
        throw error;
    }
}

export default getPublicExtensions;
